import { configureStore } from '@reduxjs/toolkit';
import authUserReducer from './reducer/authUserSlice';
import drawerReducer from './reducer/drawerSlice';
import dialogReducer from './reducer/dialogSlice';
import filterReducer from './reducer/filterSlice';
import modalReducer from './reducer/modalSlice'
import snackbarReducer from './reducer/snackbarSlice'
import menuReducer from './reducer/menu/menuSlice';
import notificationReducer from './reducer/notifications/notificationSlice';
// import userprofileRefreshReducer  from './reducer/userProfileRefreshSlice';
import recruitmentReducers from './reducer/recruitment';
import attendanceReducers from './reducer/attendace';
import leaveReducers from './reducer/leave';
import userReducers from './reducer/user';
import permissionReducers from './reducer/permissionSlice';
// import updateOfferReducer from './reducer/recruitment/offer/updateOfferSlice';
import employeeReducers from './reducer/employee';
import commonReducers from "./reducer/commonSlice";
import compensationReducer from './reducer/compensation';
import policyReducer from './reducer/companyPolicy/policySlice'
import branchLocationReducer from './reducer/branch-location/branchLocationSlice'
import branchVerticalReducer from './reducer/branch-verticalMapping/branchVerticalSlice'
import { refreshReducer } from './reducer/refreshSlice';
import notificationRefreshReducer from './reducer/notificationSlice';
import deductionExemptionSliceReducer from './reducer/tax-management/deductionExemptionSlice'
import notificationRefechReducer from './reducer/notificationRefreshSlice';
import dashboardReducer from './reducer/dashboard/dashboardSlice'


const store = configureStore({
    reducer: {
        dashboard : dashboardReducer,
        authUser: authUserReducer,
        drawer: drawerReducer,
        dialog: dialogReducer,
        filter: filterReducer,
        modal: modalReducer,
        snackbar: snackbarReducer,
        refresh: refreshReducer,
        // userprofileRefreshReducer: userprofileRefreshReducer,
        menu: menuReducer,
        notification: notificationReducer,
        ...recruitmentReducers,
        ...attendanceReducers,
        ...leaveReducers,
        ...userReducers,
        ...recruitmentReducers,
        common: commonReducers,
        ...policyReducer,
        ...employeeReducers,
        ...compensationReducer,
        permission:permissionReducers,
        policy: policyReducer,
        branchLocation: branchLocationReducer,
        branchVertical: branchVerticalReducer,
        notificationRefresh: notificationRefreshReducer,
        deductionExemption : deductionExemptionSliceReducer,
        notificationRefetch : notificationRefechReducer,
    }
});

export type RootState = ReturnType<typeof import('./store').default.getState>

export default store;